export const teamsCancellingSelector = (state) => state.api.teams.teamsCancelling;
export const teamSelector = (state) => state.api.teams.team;
export const teamsSelector = (state) => state.api.teams.teams;
export const teamSubteamsSelector = (state) => state.api.teams.teamSubteams;
export const teamUsersSelector = (state) => state.api.teams.teamUsers;
export const teamParentTeamsSelector = (state) => state.api.teams.parentTeams;
